import type { Token } from "marked";
import { Tokens } from "./tokens";
import { createElement, FC } from "react";
import { RendererProps } from "./renderers";

interface IProps {
  token: Token;
  renderers: { [key: string]: FC<RendererProps> };
}

export function Token({ token, renderers }: IProps) {
  if (token.type in renderers) {
    let renderer = renderers[token.type];
    let children = ("tokens" in token && token.tokens) ? [<Tokens tokens={token.tokens} renderers={renderers} />] : ["text" in token ? token.text : token.raw]
    return createElement(renderer, { token, renderers, children });
  } else {
    console.warn(`Invalid token: ${token.type}`);
    return (
      <pre>{token.raw}</pre>
    )
  }
}
